import ChatKioskPlaces  from './ChatKioskPlaces';

export default ChatKioskPlaces;
